// extracted by mini-css-extract-plugin
export var breakDisplay = "keyValue-module--break-display--3590c";
export var label = "keyValue-module--label--d6434";
export var value = "keyValue-module--value--9af90";